import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { DataProvider } from "./contexts/DataContext";
import { WatchListProvider } from "./contexts/WatchListContext";
import { PlayListProvider } from "./contexts/PlayListContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <DataProvider>
        <WatchListProvider>
          <PlayListProvider>
            <App />
          </PlayListProvider>
        </WatchListProvider>
      </DataProvider>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
